import * as types from 'models/actionTypes'
import { getRenderer } from 'models/refStore/selectors'
import { setIsMagicWindowLoading, setInitialLoading, updatePreviewSettings } from 'models/preview/actions'
import { getIsMagicWindowLoading, getInitialLoading, getPreviewSettings } from 'models/preview/selectors'
import { getSelectedCompositionIsLoading } from 'models/compositions/selectors'
import { getFurnitureIsLoading } from 'models/furniture/selectors'
import { getHasRendered } from 'models/renderer/selectors'

const previewMiddleware = (store) => (next) => (action) => {
    const result = next(action)
    const state = store.getState()
    switch (action.type) {
        case types.RENDERER_READY:
        case types.FIRST_RENDER:
        case types.RECEIVE_FURNITURE:
        case types.RENDER_ITEM_LOADED:
        case types.WALLART_ITEM_LOADED: {
            const hasRendered = getHasRendered(state)
            const isCompositionLoading = getSelectedCompositionIsLoading(state)
            const isMagicWindowLoading = getIsMagicWindowLoading(state)
            const isFurnitureLoading = getFurnitureIsLoading(state)
            const isInitialLoading = getInitialLoading(state)
            if (isMagicWindowLoading && !isCompositionLoading && !isFurnitureLoading) {
                store.dispatch(setIsMagicWindowLoading(false))
            }
            if (isInitialLoading && hasRendered && !isCompositionLoading && !isFurnitureLoading) {
                store.dispatch(setInitialLoading(false))
            }
            break
        }
        case types.NEW_RENDERER: {
            store.dispatch(setInitialLoading(true))
            break
        }
        case types.DESTROY_RENDERER: {
            if (getPreviewSettings(state).magicEraserMode) {
                store.dispatch(updatePreviewSettings({ magicEraserMode: false }))
            }
            const renderer = getRenderer()
            if (renderer) {
                renderer.cleanup()
            }
            break
        }
        default:
            break
    }
    return result
}

export default previewMiddleware
